
import { ClaimCategory } from "@/types";
import { Component, Vue } from "vue-property-decorator";

import * as ClaimCategoryService from "@/services/ClaimCategoryService";
import { ROOT_ACTIONS } from "@/store/actions";
import { askConfirm } from '@/content/confirm';

@Component
export default class Index extends Vue {
    categories: ClaimCategory[] = [];

    async mounted() {
        this.categories = await ClaimCategoryService.GetClaimCategories();
    }

    get organizedCategories() {
        // Sort categories so parents come before their children
        const sorted: ClaimCategory[] = [];
        const parentCategories = this.categories.filter(c => !c.parentId);
        
        parentCategories.forEach(parent => {
            sorted.push(parent);
            const children = this.categories.filter(c => c.parentId === parent.id);
            sorted.push(...children);
        });
        
        return sorted;
    }

    hasChildren(categoryId: string): boolean {
        return this.categories.some(c => c.parentId === categoryId);
    }

    get availableParentCategories() {
        // Only show top-level categories (those without a parent) as potential parents
        // Also exclude the current category being edited and its children
        return this.categories.filter(c => 
            !c.parentId && 
            c.id !== this.selectedCategory
        );
    }

    loading = {
        categories: false,
        delete: false,
        edit: false,
    }

    dialogs = {
        edit: false,
    }


    newName = '';
    selectedCategory = '';
    selectedParentId: string | null = null;
    isPopular = false;

    async deleteCategory(id: string) {
        if (!await askConfirm({ title: 'Categorie verwijderen?', text: 'De categorie wordt meteen verwijderd en kan niet teruggezet worden.', confirmLabel: 'Verwijderen', danger: true })) return;
        try {
            this.loading.categories = true;

            await ClaimCategoryService.DeleteClaimCategory(id);

            this.categories = await ClaimCategoryService.GetClaimCategories();

            this.$store.dispatch(ROOT_ACTIONS.TOGGLE_NOTIFICATION, {
                color: "success",
                text: "Categorie verwijderd",
            });

        } catch (error) {
            this.$store.dispatch(ROOT_ACTIONS.TOGGLE_NOTIFICATION, {
                color: "error",
                text: error,
            });
        } finally {
            this.loading.categories = false;
        }
    }

    async editCategory(id: string) {
        this.selectedCategory = id;
        const category = this.categories.find(x => x.id === id);
        this.newName = category?.nl ?? '';
        this.selectedParentId = category?.parentId ?? null;
        this.isPopular = category?.isPopular ?? false;
        this.dialogs.edit = true;
    }

    async submitEdit() {
        try {
            this.loading.edit = true;
            this.loading.categories = true;

            await ClaimCategoryService.UpdateClaimCategory({
                id: this.selectedCategory,
                nl: this.newName,
                parentId: this.selectedParentId,
                isPopular: this.isPopular,
            });

            this.categories = await ClaimCategoryService.GetClaimCategories();

            this.$store.dispatch(ROOT_ACTIONS.TOGGLE_NOTIFICATION, {
                color: "success",
                text: "Categorie bewerkt",
            });

        } catch (error) {
            this.$store.dispatch(ROOT_ACTIONS.TOGGLE_NOTIFICATION, {
                color: "error",
                text: error,
            });
        } finally {
            this.loading.categories = false;
            this.dialogs.edit = false;
            this.loading.edit = false;
        }
    }
}
